import { configureChains, createConfig } from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';

import { MetaMaskConnector, WalletConnectConnector } from './connectors';
import { WEB3_CONFIG } from './constants';

const { chains, publicClient, webSocketPublicClient } = configureChains(
  Object.values(WEB3_CONFIG.chains),
  [publicProvider()],
);

export const wagmiConfig = createConfig({
  autoConnect: true,
  webSocketPublicClient,
  publicClient,
  connectors: [
    new MetaMaskConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: { projectId: process.env.REACT_APP_WC_PROJECT_ID! },
    }),
  ],
});
